/* eslint-disable react/sort-comp */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu';
import Link from '@material-ui/core/Link';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Permissions from 'react-redux-permissions';
import documentIcon from '../../icons/document_logo.png';
import SectionHeader from '../../components/sectionHeader';
import styles from './document.module.scss';
import { getDirectory, getDirectoryDetail } from './redux/actions';
import Toolbar from './components/toolbar';
import folder_icon from '../../icons/folder_icon.svg';
import fileicon from '../../icons/pdf.png';
import docicon from '../../icons/doc.png';
import ppticon from '../../icons/ppt.png';
import csvicon from '../../icons/csv.png';
import xlsicon from '../../icons/xls.png';
import jpgicon from '../../icons/jpg.png';
import pngicon from '../../icons/png.png';
import mp4icon from '../../icons/mp4.png';
import mp3icon from '../../icons/mp3.png';
import movicon from '../../icons/mov.png';
import defaulticon from '../../icons/file.png';
import Clickable from '../../components/clickable/Clickable';
import Loading from '../../components/loading';
import file from '../../icons/thumbnail.png';
import { renderInfoForType } from '../../utils/helpers';

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directoryData: [],
      fileData: [],
      loadingStatus: false,
      displayview: true,
      breadCrumb: localStorage.getItem('breadCrumb') ? JSON.parse(localStorage.getItem('breadCrumb')).breadCrumb : [],
      airportCode: localStorage.getItem('breadCrumb') ? JSON.parse(localStorage.getItem('breadCrumb')).airportCode : undefined,
      intialState: false

    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    const { actionGetDirectory, actionGetDirectoryDetail, profile, history } = this.props;
    const { airportCode } = this.state;
    if (profile?.portal_airport?.code) {
      if (profile?.portal_airport?.code === airportCode) {
        const { id } = this.props.match.params;
        if (!id) {
          actionGetDirectory();
          this.setState({ breadCrumb: [], airportCode: profile.portal_airport.code });
        } else {
          actionGetDirectoryDetail(id);
        }
      } else {
        actionGetDirectory();
        localStorage.setItem('breadCrumb', JSON.stringify({ airportCode: profile.portal_airport.code, breadCrumb: [] }));
        history.push('/documents');
      }
      this.setState({ intialState: true });
    }
    this.setState({ loadingStatus: true });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.getDirectory && (props.getDirectory.directory || props.getDirectory.uploadfile)) {
      return {
        ...state,
        directoryData: props.getDirectory.directory,
        fileData: props.getDirectory.uploadfile
      };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const { airportCode, intialState } = this.state;
    const { actionGetDirectory,
      fetchDirectoryAction,
      actionGetDirectoryDetail,
      history,
      fetchDirectoryDetailAction,
      profile
    } = this.props;
    const prevId = prevProps.location.state?.state;
    const id = history.location.state?.state;
    if (!intialState && profile?.portal_airport?.code) {
      if (profile.portal_airport.code === airportCode) {
        const paramsId = this.props.match.params.id;
        if (!paramsId) {
          actionGetDirectory();
          this.setState({ breadCrumb: [], airportCode: profile.portal_airport.code });
        } else {
          actionGetDirectoryDetail(paramsId);
        }
      } else {
        actionGetDirectory();
        localStorage.setItem('breadCrumb', JSON.stringify({ airportCode: profile.portal_airport.code, breadCrumb: [] }));
        history.push('/documents');
      }
      this.setState({ intialState: true });
    }
    if (prevId !== id && intialState) {
      if (!id) {
        actionGetDirectory();
        this.setState({ breadCrumb: [] }, () => {
          localStorage.setItem('breadCrumb', JSON.stringify({ airportCode: profile.portal_airport.code, breadCrumb: [] }));
        });
      } else {
        actionGetDirectoryDetail(id);
      }
      this.setState({ loadingStatus: true });
    }

    if (fetchDirectoryDetailAction.success === true && prevProps.fetchDirectoryDetailAction.success === false) {
      this.setState({ loadingStatus: false });
    }

    if (fetchDirectoryAction.success === true && prevProps.fetchDirectoryAction.success === false) {
      this.setState({ loadingStatus: false });
    }
  }

 handleview = (list) => {
   if (list) {
     this.setState({ displayview: true });
   } else {
     this.setState({ displayview: false });
   }
 }

 handleFolder = (id) => {
   const { history, profile } = this.props;
   const { directoryData, breadCrumb } = this.state;
   this.setState({ loadingStatus: true });
   history.push(`/documents/${id}`, {
     state: id
   });
   const selectedData = directoryData.find(item => item.id === id);
   this.setState({ breadCrumb: [...breadCrumb, selectedData] });
   localStorage.setItem('breadCrumb', JSON.stringify({ airportCode: profile.portal_airport.code, breadCrumb: [...breadCrumb, selectedData] }));
 }


 getAeroFileSize = (filesize) => {
   if (filesize > 1024) {
     return `${(filesize * 0.001).toFixed(2)} KB`;
   }
   return `${(filesize * 0.001).toFixed(2)} KB`;
 };

 handlebreadcumb = (item) => {
   const { history, profile } = this.props;
   const { breadCrumb } = this.state;
   if (item === 'Home') {
     history.push('/documents');
     this.setState({ breadCrumb: [], loadingStatus: true }, () => {
       localStorage.setItem('breadCrumb', JSON.stringify({ airportCode: profile.portal_airport.code, breadCrumb: [] }));
     });
   } else {
     history.push(`/documents/${item.id}`, {
       state: item.id
     });
     const data = breadCrumb.slice(0, breadCrumb.indexOf(item + 1));
     this.setState({ breadCrumb: data, loadingStatus: true });
     localStorage.setItem('breadCrumb', JSON.stringify({ airportCode: profile.portal_airport.code, breadCrumb: data }));
   }
 }


 render() {
   const {
     loadingStatus,
     directoryData,
     fileData,
     displayview,
     breadCrumb
   } = this.state;
   const { history } = this.props;
   return (
     <>
       <Loading loadingStatus={loadingStatus} />
       <div className={styles.main_inner}>
         <SectionHeader
           icon={documentIcon}
           translationID="topbar.shared_doc"
           defaultTitle="Documents"
         />
         {/* </SectionHeader> */}

         <Toolbar
           handleview={this.handleview}
           displayview={displayview}
         />
       </div>
       {history.location.state?.state && (
       <div className={styles.breadcrumbs_inner}>
         <Breadcrumbs aria-label="breadcrumb">
           <Link
             color="inherit"
             onClick={() => this.handlebreadcumb('Home')}
           >
            Home
           </Link>
           {breadCrumb && breadCrumb.map(e => (
             (breadCrumb[breadCrumb.length - 1] === e ? (
               <Link
                 color="inherit"
                 className={styles.current_folder}
               >
                 {e.name}
               </Link>
             ) : (
               <Link
                 color="inherit"
                 onClick={() => this.handlebreadcumb(e)}
               >
                 {e.name}
               </Link>
             ))


           ))}
         </Breadcrumbs>
       </div>
        )}

       {!displayview
        && (
        <div className={styles.list_sub_inner} style={{ overflow: 'auto', border: '1px solid #E6EAEE' }}>
          <table style={{ border: 'none' }}>
            <thead>
              <tr>
                <th className="text-truncate">
                  <FormattedMessage
                    id="workorder.parts.pname"
                    defaultMessage="Name"
                  />

                </th>
                <th className="text-truncate">
                  <FormattedMessage
                    id="documents.last.updated.by"
                    defaultMessage="Last Updated By"
                  />

                </th>
                <th className="text-truncate">
                  <FormattedMessage
                    id="documents.last.updated.on"
                    defaultMessage="Last Updated On"
                  />

                </th>
                <th className="text-truncate">
                  <FormattedMessage
                    id="property.Size"
                    defaultMessage="Size"
                  />
                </th>
                <th style={{ width: '150px' }} />
              </tr>
            </thead>
            <tbody>
              {directoryData && directoryData.map(e => (
                <tr>
                  <td className={styles.list_inner}>
                    <Clickable
                      key={e.id}
                      onClick={() => this.handleFolder(e.id)}
                    >
                      <div className={styles.directory}>
                        <img src={folder_icon} alt="folder" />
                        <p style={{ width: '250px' }} className="text-truncate" title={e?.name || ''}>{e.name}</p>
                      </div>
                    </Clickable>
                  </td>
                  <td>{e.created_by && e.created_by?.fullname ? e.created_by?.fullname : 'System Generated'}</td>
                  <td>
                    {' '}
                    {renderInfoForType({ type: 'datetime' }, e.updated_at ? e.updated_at : '-', null, null)}
                  </td>
                  <td> - </td>
                </tr>
              ))}
              {fileData && fileData.map(item => (
                item.file.attachments.map(files => (
                  <tr>
                    <td>


                      <a href={files.url} target="_blank" rel="noopener noreferrer">
                        <div className={styles.list_filecontent} style={{ width: '250px' }}>

                          {files ? (
                  files.file_name?.split('.').pop() === 'doc' || files.file_name?.split('.').pop() === 'docx' ? (
                    <img src={docicon} alt="file-img" />
                  ) : (
                    files.file_name?.split('.').pop() === 'pdf' ? (
                      <img src={fileicon} alt="file-img" />
                    ) : (
                      (files.file_name?.split('.').pop() === 'ppt' || files.file_name?.split('.').pop() === 'pptx') ? (
                        <img src={ppticon} alt="file-img" />
                      ) : (
                      files.file_name?.split('.').pop() === 'csv' ? (
                        <img src={csvicon} alt="file-img" />
                      ) : (
                      files.file_name?.split('.').pop() === 'xls' ? (
                        <img src={xlsicon} alt="file-img" />
                      ) : (
                        files.file_name?.split('.').pop() === 'jpg' ? (
                          <img src={jpgicon} alt="file-img" />
                        ) : (
                        files.file_name?.split('.').pop() === 'png' ? (
                          <img src={pngicon} alt="file-img" />
                        ) : (
                          files.file_name?.split('.').pop() === 'mp4' ? (
                            <img src={mp4icon} alt="file-img" />
                          ) : (
                          files.file_name?.split('.').pop() === 'mp3' ? (
                            <img src={mp3icon} alt="file-img" />
                          ) : (
                            files.file_name?.split('.').pop() === 'mov' ? (

                              <img src={movicon} alt="file-img" />
                            ) : (
                              <img src={defaulticon} alt="file-img" />

                            )
                          )
                          )
                        )
                        )
                      )
                      )
                      )
                    )
                  )
                          ) : (
                            <div className={styles.emptyData}>Content not available</div>
                          )}

                          <p className="text-truncate" title={item?.file?.name || files?.file_name || ''}>
                            {item.file.name || files.file_name}
                          </p>

                        </div>
                      </a>


                    </td>
                    <td>{item.file.created_by && item.file.created_by?.fullname ? item.file.created_by?.fullname : '-'}</td>
                    <td>
                      {renderInfoForType({ type: 'datetime' }, item.file.updated_at ? item.file.updated_at : '-', null, null)}
                    </td>
                    <td>{this.getAeroFileSize(files.file_size)}</td>
                  </tr>
                ))
              ))}

            </tbody>
          </table>

        </div>
        )

        }


       {displayview

        && (
        <div className={styles.grid_main_inner}>
          <div className={styles.main_sub_inner}>

            {directoryData && directoryData.map(e => (
              <ContextMenuTrigger id={e.id} className={styles.main_dir}>
                <div>
                  <Clickable
                    key={e.id}
                    onClick={() => this.handleFolder(e.id)}
                  >
                    <div className={styles.directory}>
                      <img src={folder_icon} alt="folder" />
                      <p className="text-truncate" title={e.name}>{e.name}</p>
                    </div>
                  </Clickable>
                </div>
                {
                !e.system_generated && (
                <ContextMenu className={styles.menu} id={e.id}>
                  <Permissions allowed={['change_directory']}>
                    <MenuItem
                      onClick={() => this.toggleDirectoryUpdateModal(e.id, e.name)}
                      data={{ item: 'Update' }}
                      className="menuItem"
                    >
                Update
                    </MenuItem>
                  </Permissions>


                  <Permissions allowed={['delete_directory']}>
                    <MenuItem
                      onClick={() => this.handleDeleteDirectory(e.id)}
                      data={{ item: 'Delete' }}
                      className="menuItem"
                    >
                Delete
                    </MenuItem>
                  </Permissions>


                </ContextMenu>
                )
    }
              </ContextMenuTrigger>
            ))}


          </div>
          <div className={styles.uploadfiles}>
            {fileData && fileData.map(item => (
              item.file.attachments.map(files => (
                <div>
                  <ContextMenuTrigger id={files.id}>
                    <div className={styles.filecontent} style={{ width: '250px' }}>
                      <a href={files.url} target="_blank" rel="noopener noreferrer">

                        {
                      files ? (
                      files.file_name?.split('.').pop() === 'jpg' || files.file_name?.split('.').pop() === 'png' || files.file_name?.split('.').pop() === 'jpeg' ? (
                        <img src={files.url} alt="file-img" />
                      ) : (
                        <img src={file} alt="file-img" />
                      )
                      ) : (
                        <div className={styles.emptyData}>Content not available</div>
                      )}
                        <div className={styles.files_description}>

                          {files ? (
                  files.file_name?.split('.').pop() === 'doc' || files.file_name?.split('.').pop() === 'docx' ? (
                    <img src={docicon} alt="file-img" />
                  ) : (
                    files.file_name?.split('.').pop() === 'pdf' ? (
                      <img src={fileicon} alt="file-img" />
                    ) : (
                      (files.file_name?.split('.').pop() === 'ppt' || files.file_name?.split('.').pop() === 'pptx') ? (
                        <img src={ppticon} alt="file-img" />
                      ) : (
                      files.file_name?.split('.').pop() === 'csv' ? (
                        <img src={csvicon} alt="file-img" />
                      ) : (
                      files.file_name?.split('.').pop() === 'xls' ? (
                        <img src={xlsicon} alt="file-img" />
                      ) : (
                        files.file_name?.split('.').pop() === 'jpg' ? (
                          <img src={jpgicon} alt="file-img" />
                        ) : (
                        files.file_name?.split('.').pop() === 'png' ? (
                          <img src={pngicon} alt="file-img" />
                        ) : (
                          files.file_name?.split('.').pop() === 'mp4' ? (
                            <img src={mp4icon} alt="file-img" />
                          ) : (
                          files.file_name?.split('.').pop() === 'mp3' ? (
                            <img src={mp3icon} alt="file-img" />
                          ) : (
                            files.file_name?.split('.').pop() === 'mov' ? (

                              <img src={movicon} alt="file-img" />
                            ) : (
                              <img src={defaulticon} alt="file-img" />

                            )
                          )
                          )
                        )
                        )
                      )
                      )
                      )
                    )
                  )
                          ) : (
                            <div className={styles.emptyData}>Content not available</div>
                          )}
                          <p className="text-truncate" title={item?.file?.name || ''}>
                            {item.file.name}
                          </p>
                        </div>
                      </a>
                    </div>
                  </ContextMenuTrigger>
                </div>
              ))
            ))}
          </div>
        </div>
        )
        }
     </>
   );
 }
}

Document.propTypes = {

  history: PropTypes.shape({}).isRequired

};


const mapStateToProps = state => ({
  getDirectory: state.documents.schemas,
  fetchDirectoryDetailAction: state.documents.fetchDirectoryDetailAction,
  fetchDirectoryAction: state.documents.fetchDirectoryAction,
  profile: state.auth.profile
});


const mapDispatchToProps = dispatch => ({

  actionGetDirectory: (query) => {
    dispatch(getDirectory(query));
  },
  actionGetDirectoryDetail: (id, query) => {
    dispatch(getDirectoryDetail(id, query));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Document);
